import type { LocationQuery } from 'vue-router';
import type { VersionsModel } from '../common/models/versions.model';

export function resolveFunnelVersions(
  query: LocationQuery,
  funnelKey: string,
  funnelConfig: { quizVer: string | null, homeVer: string | null, landingVer?: string, homePageConfig?: { loaderHomeVer: string | null } },
  stored: Partial<VersionsModel> | null,
): VersionsModel {
  const BASE_LINE_VERSION = '1';
  const { ver, hp, l, p, mixmin } = query;
  let minimalMixpanel;
  if (mixmin) {
    minimalMixpanel = mixmin === '1' ? '0' : '1';
  }

  return {
    paymentForm: '1',
    quiz: ver as string || (funnelConfig.quizVer ?? BASE_LINE_VERSION),
    homePage: hp as string || (funnelConfig.homeVer ?? funnelConfig.homePageConfig?.loaderHomeVer ?? 'NewSS1'),
    landing: l as string || (funnelConfig.landingVer ?? BASE_LINE_VERSION),
    upsale: p as string || String(stored?.upsale || BASE_LINE_VERSION),
    trackOnlyAfterQuiz: minimalMixpanel || String(stored?.trackOnlyAfterQuiz || BASE_LINE_VERSION),
    funnel: funnelKey,
  };
}
